import Castle from "@castleio/castle-js";

let isConfigured = false;

const getCastle = () => {
  if (!isConfigured) {
    Castle.configure({ pk: process.env.REACT_APP_CASTLE_PUBLIC_KEY });
    isConfigured = true;
  }
  return Castle;
};

export function getCastleRequestToken() {
  // Tokens expire and belong to one backend request, including after account switches.
  return getCastle().createRequestToken();
}

export default getCastle;
